import { Channel } from 'phoenix'
import { chatApi } from './utils'
import { Settings } from '.'
import {
  CannedResponse,
  CannedResponseRaw,
  Chat,
  ChatRaw,
  KbTopic,
  KbTopicRaw,
  MiddlewareCommand,
  Story,
} from './types'
import { convertChats } from './chatConverter'

export const getChats = async (channel: Channel) => {
  let chats: Chat[] = []

  for (const chatAccount of window.c.chatAccounts) {
    const resp = await chatApi<ChatRaw[]>(channel, chatAccount.id, {
      module: 'talk',
      method: 'getOperatorChats',
    })

    const chatsForAccount = await convertChats(resp, chatAccount.id)

    chats = chats.concat(chatsForAccount)
  }

  if (chats.length) {
    chats[0].active = true
  }

  return chats
}

//

export const getCannedResponsesAndStories = async (channel: Channel) => {
  let itemsStories = {}
  let itemsCannedResponses = {}

  for (const chatAccount of window.c.chatAccounts) {
    const resp = await chatApi<CannedResponseRaw[]>(channel, chatAccount.id, {
      module: 'talk',
      method: 'getOperatorScripts',
    })

    itemsStories[chatAccount.id] = resp.filter(item => item.mode == 0)
    itemsCannedResponses[chatAccount.id] = resp.filter(item => item.mode == 4)

    // itemsCannedResponses[chatAccount.id] = []
    // itemsCannedResponses[chatAccount.id].push({
    //   scriptId: 0,
    //   scriptName: 'Account locked',
    //   scriptMessageCopy:
    //     'It seems too many login attempts locked your account. Please wait for 1 hour before trying again.',
    //   scriptMessage:
    //     'It seems too many login attempts locked your account. Please wait for 1 hour before trying again.',
    //   mode: 4,
    // })
    // itemsCannedResponses[chatAccount.id].push({
    //   scriptId: 1,
    //   scriptName: 'Restart',
    //   scriptMessageCopy: 'Have you tried turning it off and on again?',
    //   scriptMessage: 'Have you tried turning it off and on again?',
    //   mode: 4,
    // })
  }

  return [
    convertStories(itemsStories),
    convertCannedResponse(itemsCannedResponses),
  ] as [Story[], CannedResponse[]]
}

const convertStories = (groups: { [key: number]: CannedResponseRaw[] }) => {
  let items: Story[] = []

  for (const chatAccountId in groups) {
    items = items.concat(
      groups[chatAccountId].map(item => ({
        id: 'story' + item.scriptId,
        originId: item.scriptId,
        name: item.scriptName,
        search: `${item.scriptName} ${item.scriptMessageCopy}`.removeAccents(),
        chatAccountId: parseInt(chatAccountId),
        type: 'story',
      }))
    )
  }

  return items
}

const convertCannedResponse = (groups: {
  [key: number]: CannedResponseRaw[]
}) => {
  let items: CannedResponse[] = []

  for (const chatAccountId in groups) {
    items = items.concat(
      groups[chatAccountId].map(item => ({
        id: 'cannedResponse' + item.scriptId,
        originId: item.scriptId,
        name: item.scriptName,
        search: `${item.scriptName} ${item.scriptMessageCopy}`.removeAccents(),
        message: item.scriptMessageCopy,
        messageHtml: item.scriptMessage,
        chatAccountId: parseInt(chatAccountId),
        type: 'cannedResponse',
      }))
    )
  }

  return items
}

//

export const getKnowledgebaseTopics = async (
  channel: Channel,
  spaceId: number,
  searchPhrase = ''
) => {
  let items = {}

  for (const chatAccount of window.c.chatAccounts) {
    const resp = await chatApi<KbTopic[]>(channel, chatAccount.id, {
      module: 'talk',
      method: 'getOperatorTopics',
      args: [spaceId, searchPhrase],
    })

    items[chatAccount.id] = resp
  }

  return kbTopicsConverter(items)
}

const kbTopicsConverter = (groups: { [key: number]: KbTopicRaw[] }) => {
  let items: KbTopic[] = []

  for (const chatAccountId in groups) {
    items = items.concat(
      groups[chatAccountId].map((item, key) => ({
        id: 'kbTopic' + key,
        originId: key,
        name: item.topicName,
        message: item.topicMessageCopy,
        messageHtml: item.topicMessage,
        search: `${item.topicName} ${item.topicMessageCopy}`.removeAccents(),
        active: false,
        chatAccountId: parseInt(chatAccountId),
        type: 'kbTopic',
      }))
    )
  }

  return items
}

//

export const getMiddlewareMethods = async (channel: Channel) => {
  let items: MiddlewareCommand[] = []

  for (const chatAccount of window.c.chatAccounts) {
    const resp = await chatApi<MiddlewareCommand[]>(channel, chatAccount.id, {
      module: 'talk',
      method: 'listMiddlewareMethods',
    })

    items = items.concat(resp)
  }

  return items
}

//

export const getSettings = async (channel: Channel): Promise<Settings> => {
  let items = {}

  for (const chatAccount of window.c.chatAccounts) {
    const get = async (service: string, name: string, defaultVal: any) =>
      await chatApi(channel, chatAccount.id, {
        module: 'session',
        method: 'getSetting',
        args: [service, name, defaultVal],
      })

    const forceTagBeforeClose = await get(
      'talk',
      'LC_FORCE_TAG_BEFORE_CLOSE',
      false
    )

    items[chatAccount.id] = {
      forceTagBeforeClose,
    }
  }

  return items
}
